import { Button, Modal, Popup } from 'semantic-ui-react';
import React, { useCallback, useState } from 'react';
import { getListByPreparationId } from 'services/manifests.service';
import { useAlert } from 'context/AlertProvider';
import { getMessageFromAxiosError } from 'modules/message-factory/message-factory';
import ManifestsList from 'components/ManifestsList/ManifestsList';
import ZebraProvider from 'context/ZebraProvider';

export default function ManifestsModal({ preparationOrderId }) {
  const alert = useAlert();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [manifests, setManifests] = useState([]);

  const fetchManifests = useCallback(async () => {
    try {
      setLoading(true);
      const { data: manifests } = await getListByPreparationId(
        preparationOrderId,
      );
      setManifests(manifests);
    } catch (error) {
      alert.current.error(getMessageFromAxiosError(error));
    } finally {
      setLoading(false);
    }
  }, [alert, preparationOrderId]);

  return (
    <Modal
      open={modalIsOpen}
      onClose={() => setModalIsOpen(false)}
      onMount={() => fetchManifests(preparationOrderId)}
      trigger={
        <Popup
          className="base-tooltip"
          content="Listar manifiestos"
          trigger={
            <Button
              circular
              icon="file pdf outline"
              onClick={() => setModalIsOpen(true)}
            />
          }
        />
      }
    >
      <Modal.Header>Manifiestos</Modal.Header>
      <Modal.Content>
        <ZebraProvider>
          <ManifestsList manifests={manifests} loading={loading} />
        </ZebraProvider>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setModalIsOpen(false)}>Cancelar</Button>
      </Modal.Actions>
    </Modal>
  );
}
